<template>
  <VAceEditor
    ref="editor"
    :options="{
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      enableSnippets: true,
      useWorker: true,
      showPrintMargin: false,
      highlightActiveLine: true,
      fontSize: '14px'
    }"
    theme="chrome"
    style="min-height: 250px; width: 100%"
    @blur="null"
    @change="null"
    @input="null" />
</template>

<script>
import { VAceEditor } from 'vue3-ace-editor'
import './ace.config'
export default {
  components: {
    VAceEditor
  },
  data() {
    return {
      instance: null
    }
  },
  mounted() {
    this.instance = this.$refs.editor?.getAceInstance()
    this.instance?.on('change', this.input)
    this.instance?.on('blur', this.change)
  },
  unmounted() {
    this.instance = null
  },
  methods: {
    input() {
      this.$emit('input', this.instance?.getValue() || '')
      this.$emit('update:modelValue', this.instance?.getValue() || '')
    },
    change() {
      this.$emit('change', this.instance?.getValue() || '')
    }
  }
}
</script>
